import * as React from "react";
import { createInstance, Piral, createMenuApi } from "piral";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
import { createStore, IModuleStore } from "redux-dynamic-modules";
import { getThunkExtension } from "redux-dynamic-modules-thunk";
import { FeatureToggle, createFeatureToggleApi } from "@piral/feature-management";
import { extendApi } from "./extendApi";
import { layout, errors } from "./layout";
import { PiwikContainer } from "./components/PiwikContainer";
import { PiwikService } from "./piwik/PiwikService";
import allReducers from "./store";
import { createLanguageApi } from "./plugins/language/extendApi/LanguageExtendApi";
import { createFormPageLayoutComponentApi } from "./plugins/FormPageLayout/FormPageLayoutExtendApi";
import { openCakToggles } from "./plugins/featureToggle/extendApi/FeatureToggleExtendApi";
import env from "./env";

export interface IRenderProps {
  language: string;
  allFeaturesToggle: FeatureToggle[];
}

export const OpenCak = (props: IRenderProps) => {
  const openCakStore: IModuleStore<unknown> = createStore(
    {
      initialState: {},
      extensions: [getThunkExtension()],
      enhancers: []
    },
    {
      id: "opencak-store",
      reducerMap: allReducers,
      initialActions: [],
      finalActions: []
    }
  );

  const removeTrailingSlash = (path: string) => {
    if (path && path.substring(path.length - 1) === "/") {
      return path.slice(0, -1);
    }

    return path;
  };

  const instance = createInstance({
    state: {
      data: {
        "base-path": {
          value: removeTrailingSlash(env.APPLICATION_PATH),
          owner: "",
          target: "memory",
          expires: -1
        },
        "api-path": {
          value: env.API ?? "",
          owner: "",
          target: "memory",
          expires: -1
        }
      },
      components: layout(
        props.allFeaturesToggle.find((feature) => feature.name.toLowerCase() === "cobrowsing")?.enabled
      ),
      errorComponents: errors
    },

    plugins: [
      createMenuApi(),
      extendApi(openCakStore),
      createFeatureToggleApi(openCakToggles(env.API ?? "", props.allFeaturesToggle)),
      createLanguageApi(props.language),
      createFormPageLayoutComponentApi()
    ],
    requestPilets() {
      return fetch(`${env.API}/api/v1/pilet`)
        .then((res) => res.json())
        .then((res) => res.items);
    }
  });

  instance.root.registerPage(env.APPLICATION_PATH || "/", () => <></>);
  return (
    <CookiesProvider>
      <Provider store={openCakStore}>
        <div className="app-shell">
          <Piral instance={instance}>
            <PiwikContainer piwik={new PiwikService()} />
          </Piral>
        </div>
      </Provider>
    </CookiesProvider>
  );
};
